// The carousel section's height as an inline CSS value. It was given as a
// Tailwind class stored in the section ("h-96", "min-h-[60dvh]"); classes that
// only exist in data are never compiled, so the root had no height and the
// absolutely positioned slides drew nothing. Pure, for tests/carouselHeight.test.js.

const SCALE = {"64": "16rem", "72": "18rem", "80": "20rem", "96": "24rem", "screen": "100vh"};
export const DEFAULT_CAROUSEL_HEIGHT = "min(70vh, 40rem)";

export function carouselHeight(height) {
    if (typeof height !== "string" || !height.trim()) return DEFAULT_CAROUSEL_HEIGHT;
    const v = height.trim();
    const arbitrary = v.match(/^(?:min-)?h-\[([0-9.]+(?:px|rem|em|vh|dvh|svh|%))\]$/);
    if (arbitrary) return arbitrary[1];
    const scale = v.match(/^(?:min-)?h-(\d+|screen)$/);
    if (scale && SCALE[scale[1]]) return SCALE[scale[1]];
    if (/^[0-9.]+(px|rem|vh|dvh)$/.test(v)) return v;
    return DEFAULT_CAROUSEL_HEIGHT;
}
